<app-performance-table
  [performances]="tables$ | async"
  [performancesLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (tableCallback)="getTableCallback($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
></app-performance-table>
